module.exports = __webpack_public_path__ + "img/logo-512x512.eee6d47b.png";